import {useEffect, useState} from 'react';
import { Wifi, MapPin, Search, CreditCard } from 'lucide-react';
import { useApp } from "@/contexts/AppContext";
import { Helmet } from "react-helmet-async";
import { Loader2, Users, X, Zap, Sparkles, QrCode } from 'lucide-react';
import {getDashboardOverflow, getSubscription} from '../../api/services/dashboardService';
import {getActiveSubscription, cancelSubscription, getConnectionHistory} from '../../api/services/subscription';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getErrorMessage } from '@/utils/errorUtils';

// import { Helmet } from "react-helmet-async";
import FeedbackModal from '@/components/FeedbackModal';
import {
  searchHotspots,
  type EndUserHotspot as Hotspot,
  disconnectFromHotspot,
    connectToHotspot,
  type HotspotSearchParams,
  getNearbyHotspots
  
} from '@/api/services/hotspotService';

// Returns a stable per-browser device identifier. Generated once on first call,
// then reused across the app for hotspot connections.
const getDeviceId = (): string => {
  let id = localStorage.getItem('konectx_device_id');
  if (!id) {
    id = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : 'dev-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    localStorage.setItem('konectx_device_id', id);
  }
  return id;
};

export default function KonnectXEndusersDashboard(){

  const { theme } = useApp();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [langOverride, setLangOverride] = useState(
    localStorage.getItem('i18nextLng')?.startsWith('fr') ? 'fr' : 'en'
  );
  const t = i18n.getFixedT(langOverride);
  const [, setCurrentLang] = useState(langOverride);
  const [data, setdata] = useState(null);
  const [loading, setloading] = useState(true);
  const [subscription, setSubscription] = useState(null);

  const [activeSubscription, setActiveSubscription] = useState(null);
  const [searchdisplay, setSearchDisplay] = useState(false)
    const [searchQuery, setSearchQuery] = useState('');
    const [searchData, setSearchData] = useState(null);
    const [searchloading, setsearchloading] = useState(true);
  const [getconnectedhotspotstatus, setconnectedhotspotstatus] = useState(false);
  const [getconnectedhotspot, setconnectedhotspot] = useState(null);
  const [recentConnections, setRecentConnections] = useState<unknown[]>([]);
  const [recentPagination, setRecentPagination] = useState<unknown>(null);
  const [recentPage, setRecentPage] = useState(1);
  const [recentLoadingMore, setRecentLoadingMore] = useState(false);
  const [recentHasMore, setRecentHasMore] = useState(true);

  // Removed pendingPlanTopup redirect to allow users to access their dashboard even if a topup was cancelled

    useEffect(()=>{
      if(localStorage.getItem('connectedhotspot') === null || localStorage.getItem('connectedhotspot') === undefined){
        setconnectedhotspotstatus(false);
      } else {
        setconnectedhotspot(localStorage.getItem('connectedhotspot'));
        setconnectedhotspotstatus(true);
      }
    }, [getconnectedhotspotstatus, getconnectedhotspot]);
  
  const loadRecentConnections = async (page: number, limit: number, append: boolean) => {
    try {
      if (append) {
        setRecentLoadingMore(true);
      }
      const response = await getConnectionHistory(page, limit);
      const connections = response?.data?.connections || [];
      setRecentConnections((prev) => (append ? [...prev, ...connections] : connections));
      setRecentPagination((response?.data?.pagination ?? null) as Record<string, unknown> | null);
      setRecentHasMore(
        response?.data?.pagination ? ((response.data.pagination as unknown as Record<string, unknown>).page as number) < ((response.data.pagination as unknown as Record<string, unknown>).totalPages as number) : false
      );
      setRecentPage(page);
    } catch (err: unknown) {
      console.error('Error fetching recent connections:', err);
      if (!append) {
        setRecentConnections([]);
        setRecentHasMore(false);
      }
    } finally {
      if (append) {
        setRecentLoadingMore(false);
      }
    }
  };

  const handleLoadMoreRecent = async () => {
    if (!recentPagination) return;
    if ((recentPagination as Record<string, unknown>).page >= (recentPagination as Record<string, unknown>).totalPages) {
      setRecentHasMore(false);
      return;
    }
    const nextPage = recentPage + 1;
    await loadRecentConnections(nextPage, 10, true);
  };

  useEffect(() => {
    const onLanguageChanged = (lng: string) => {
      setCurrentLang(lng);
    };
    const onAppLanguageChanged = (event: Event) => {
      const next = (event as CustomEvent).detail as string;
      const normalized = next?.startsWith('fr') ? 'fr' : 'en';
      setLangOverride(normalized);
      setCurrentLang(normalized);
    };
    i18n.on('languageChanged', onLanguageChanged);
    window.addEventListener('appLanguageChanged', onAppLanguageChanged as EventListener);
    return () => {
      i18n.off('languageChanged', onLanguageChanged);
      window.removeEventListener('appLanguageChanged', onAppLanguageChanged as EventListener);
    };
  }, [i18n]);

  useEffect(() => {
    const storedLang = localStorage.getItem('i18nextLng');
    if (storedLang) {
      const normalized = storedLang.startsWith('fr') ? 'fr' : 'en';
      setLangOverride(normalized);
      if (i18n.language !== normalized) {
        i18n.changeLanguage(normalized);
      }
    }
    async function fetchDashboardoverflow(){
      let response = await getDashboardOverflow();
      console.log('Dashboard Overflow Data:', response);
      setdata((response as Record<string, unknown>).data as never)
    }
    async function fetchDashboardsubscription(){
      let response = await getSubscription();
      console.log('Dashboard Subscription Data:', response);
      setSubscription((response as Record<string, unknown>).data as never)
    }
    async function fetchActivesubscription(){
      let response = await getActiveSubscription();
      console.log('Dashboard Subscription Data:', response);
      setActiveSubscription(response.data as never)
    }

    
   async function Render(){
      // Use allSettled so one failing API doesn't break the whole dashboard.
      // Each fetch sets its own state, so partial-success is fine.
      const results = await Promise.allSettled([
        fetchDashboardoverflow(),
        fetchDashboardsubscription(),
        fetchActivesubscription(),
        loadRecentConnections(1, 10, false)
      ]);
      results.forEach((r, i) => {
        if (r.status === 'rejected') {
          console.error(`Dashboard fetch #${i} failed:`, r.reason);
        }
      });
      setloading(false);
    }
    Render();
  }, []);

const fetchHotspots = async () => {
        try {
          setsearchloading(true);
          
          const params: HotspotSearchParams = {
            search: searchQuery || undefined,
            // city: cityFilter,
            // speed: "All speed",
            // status: "All status",
            page: 1,
            limit: 10
          };
          
          console.log('Fetching hotspots with params:', params);
          
          const response = await searchHotspots(params);
          console.log('Search hotspots response:', response);
          
          if (response?.data?.hotspots) {
            setSearchData(response.data.hotspots);
            // setPagination(response.data.pagination);
          } else {
            console.warn('No hotspots in response:', response);
            setSearchData([]);
          }
        } catch (error: unknown) {
          console.error('Error fetching hotspots:', error);
          // setFeedbackData({
          //   type: 'error',
          //   title: 'Failed to Load Hotspots',
          //   message: error.message || 'Unable to fetch hotspots. Please try again.'
          // });
          // setShowFeedback(true);
          setSearchData([]);
        } finally {
          setsearchloading(false);
        }
      };

useEffect(()=> {
fetchHotspots();
}, [searchQuery])

const [connectingHotspotId, setConnectingHotspotId] = useState<string | null>(null);
const [selectedHotspot, setSelectedHotspot] = useState<Hotspot | null>(null);
 const [showConnectionConfirm, setShowConnectionConfirm] = useState(false);
 const [showFeedback, setShowFeedback] = useState(false);
 // When true, closing the feedback modal reloads the page (e.g. after a
 // successful cancellation) so the dashboard reflects the new state.
 const [reloadOnFeedbackClose, setReloadOnFeedbackClose] = useState(false);
const [feedbackData, setFeedbackData] = useState<{
    type: 'success' | 'error' | 'warning' | 'info';
    title: string;
    message: string;
  }>({ type: 'success', title: '', message: '' });

  const handleConnect = (hotspot: Hotspot) => {
    setSelectedHotspot(hotspot);
    setShowConnectionConfirm(true);
  };

  const confirmConnect = async (selectedHotspot: Hotspot | null) => {
    if (!selectedHotspot) return;

    try {
      setConnectingHotspotId(selectedHotspot.id);

      const response = await connectToHotspot(selectedHotspot.id, getDeviceId());

      localStorage.setItem('connectedhotspot', selectedHotspot.id);
      setconnectedhotspot(selectedHotspot.id);

      setFeedbackData({
        type: 'success',
        title: 'Connected Successfully!',
        message: `You are now connected to "${selectedHotspot.name}". Enjoy your WiFi!`
      });
      setShowFeedback(true);
      setShowConnectionConfirm(false);

      console.log('Connection details:', response.data);
    } catch (error: unknown) {
      console.error('Connection error:', error);
      setShowConnectionConfirm(false);

      // Defensively parse the error — service may throw either a plain string
      // or a JSON-stringified object containing activeConnectionId, etc.
      let errorMessage = 'Failed to connect to hotspot. Please try again.';
      let activeConnectionId: string | null = null;
      try {
        const parsed = JSON.parse(String((error as unknown as Record<string, unknown>).message));
        errorMessage = parsed?.message || errorMessage;
        activeConnectionId = parsed?.activeConnectionId || null;
      } catch {
        errorMessage = String((error as unknown as Record<string, unknown>).message || errorMessage);
      }

      if (activeConnectionId) {
        errorMessage = 'You are already connected to another hotspot. Please disconnect from it first.';
      }

      setFeedbackData({
        type: 'error',
        title: 'Connection Failed',
        message: errorMessage
      });
      setShowFeedback(true);
    } finally {
      setConnectingHotspotId(null);
    }
  };


  const disconnecthotspot = async (id: string) => {
    try {
      const response = await disconnectFromHotspot(id, id);
      console.log('Disconnect response:', response);
      localStorage.removeItem('connectedhotspot');
      setconnectedhotspot(null);
      setFeedbackData({
        type: 'success',
        title: 'Disconnected',
        message: 'You have been disconnected from the hotspot.'
      });
      setShowFeedback(true);
    } catch (err: unknown) {
      console.error('Disconnect error:', err);
      setFeedbackData({
        type: 'error',
        title: 'Disconnect Failed',
        message: getErrorMessage(err) || 'Failed to disconnect from hotspot. Please try again.'
      });
      setShowFeedback(true);
    }
  };
  const [cancelLoading, setcancelLoading] = useState(false);

  const confirmCancelSubscription = async () => {
    if (!subscription) return;
    
    try {
      setcancelLoading(true);
      
      const response = await cancelSubscription(
        activeSubscription.subscriptionId, 
        'No reason provided', 
        false
      );
      
      // Update local state
      setSubscription(prev => prev ? { ...prev, status: 'cancelled' } : null);
      setActiveSubscription(prev => prev ? { ...prev, status: 'cancelled' } : null);

      // Resolve the end date from the API response first, then local state.
      // Only format it when it's a valid date — otherwise show a friendly phrase
      // instead of "Invalid Date".
      const respData = (response as unknown as Record<string, unknown>)?.data as Record<string, unknown> | undefined;
      const rawEndDate =
        (respData?.endDate as string | undefined) ||
        (respData?.expiresAt as string | undefined) ||
        activeSubscription?.endDate ||
        (subscription as Record<string, unknown> | null)?.endDate as string | undefined;
      const parsed = rawEndDate ? new Date(rawEndDate) : null;
      const endDateText = parsed && !isNaN(parsed.getTime())
        ? parsed.toLocaleDateString()
        : 'the end of your billing period';
      setFeedbackData({
        type: 'success',
        title: 'Subscription Cancelled',
        message: `Your subscription has been cancelled. It will remain active until ${endDateText}.`
      });
      setShowFeedback(true);
      // Reload once the user acknowledges the success modal so the dashboard
      // reflects the cancelled subscription.
      setReloadOnFeedbackClose(true);
    } catch (err: unknown) {
      console.error('Error cancelling subscription:', err);
      setFeedbackData({
        type: 'error',
        title: 'Cancellation Failed',
        message: String((err as unknown as Record<string, unknown>).message || 'Failed to cancel subscription. Please try again.')
      });
      setShowFeedback(true);
    }
     finally {
      setcancelLoading(false);
    }
  };

  const [nearbyhotspot, setnearbyhotspot] = useState(null); 
  const [nearbyloading, setnearbyloading] = useState(false); 

 const geolocation = async ()=> {
  setnearbyloading(true);
  navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;
  let response = await getNearbyHotspots(lat, lon, 10);
        setnearbyhotspot(response.data.nearbyHotspots);
        // document.getElementById("output").innerText =
        //   `Latitude: ${lat}, Longitude: ${lon}`;
  setnearbyloading(false);

        console.log(lat, lon, response, "lat, lon");
      },
      (error) => {
        // document.getElementById("output").innerText =
        //   "Unable to retrieve your location.";
        console.error(error);
  setnearbyloading(false);

      }
    );
}


useEffect(()=> {
geolocation();
}, []);

if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-black flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  }

  // console.log(activeSubscription, 'active')

  return (
    <>
          <Helmet>
            <title>Dashboard Overview | KonectX</title>
            <meta
              name="description"
              content="Get a comprehensive overview of your KonectX dashboard. Track hotspots, manage rewards, referrals, and monitor your KXT token activities."
            />
            <meta
              name="keywords"
              content="KonectX, dashboard overview, hotspots, rewards, referrals, KXT token, decentralized network"
            />
            <meta property="og:title" content="Dashboard Overview - KonectX" />
            <meta
              property="og:description"
              content="Get a comprehensive overview of your KonectX dashboard. Track hotspots, manage rewards, referrals, and monitor your KXT token activities."
            />
          </Helmet>

    <div className="p-9" key={langOverride}>
      
    {/* Header */}
<div className="mb-8">
  <div className={`${theme === 'dark' ? 'bg-[#4347f8]' : 'bg-[#4347f8]'} rounded-2xl p-8 shadow-lg`}>
   {/* Dashboard label */}
<div className="flex items-center gap-2 mb-4">
  <Sparkles
    size={20}
    className="text-white"
  />
  <span className="text-white text-sm font-medium">
    {t('enduser.dashboardOverview.dashboardLabel')}
  </span>
</div>
    
    {/* Welcome message */}
    <h1 className="text-white text-4xl font-bold mb-2">
      {t('enduser.dashboardOverview.welcomeheadermessage')} {data?.user.firstName}
    </h1>
    <p className="text-white text-opacity-90 text-base">
      {t('enduser.dashboardOverview.welcomebodymessage')}
    </p>
  </div>
</div>



{/* Stats Grid */}
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
  {/* Active Plan */}
  <div className={`${theme === 'dark' ? 'bg-[#333436] backdrop-blur-xl' : 'bg-white/80 backdrop-blur-xl'} rounded-2xl p-6 shadow-lg border ${theme === 'dark' ? 'border-gray-800' : 'border-gray-100'}`}>
    <div className="flex items-center justify-between mb-4">
      <div className="w-14 h-14 bg-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
        <Wifi className="w-7 h-7 text-white" />
      </div>
      <span className={`${theme === 'dark' ? 'bg-blue-500/20 text-blue-400' : 'bg-blue-50 text-blue-600'} px-3 py-1 rounded-full font-semibold text-sm`}>
        {activeSubscription !== null
          ? t('enduser.dashboardOverview.status.active')
          : t('enduser.dashboardOverview.status.inActive')}
      </span>
    </div>
    <p className={`text-sm mb-2 font-medium ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>{t('enduser.dashboardOverview.activeplan')}</p>
    {activeSubscription ? <h3 className={`text-2xl font-bold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
       {activeSubscription?.plan?.name} ({activeSubscription?.plan?.period})
    </h3> : ''}
    {activeSubscription !== null && (
      <p className={`text-sm font-medium ${theme === 'dark' ? 'text-gray-500' : 'text-gray-500'}`}>
        {t('enduser.dashboardOverview.Expireson')} {activeSubscription?.endDate ? new Date(activeSubscription?.endDate).toLocaleDateString() : ""}
      </p>
    )}
    {activeSubscription === null && (
      <p className={`text-sm font-medium ${theme === 'dark' ? 'text-gray-500' : 'text-gray-500'}`}>{t('enduser.dashboardOverview.noactiveplan')}</p>
    )}
  </div>

  {/* Data Usage */}
  <div className={`${theme === 'dark' ? 'bg-[#333436] backdrop-blur-xl' : 'bg-white/80 backdrop-blur-xl'} rounded-2xl p-6 shadow-lg border ${theme === 'dark' ? 'border-gray-800' : 'border-gray-100'}`}>
    <div className="flex items-center justify-between mb-4">
      <div className="w-14 h-14 bg-purple-600 rounded-2xl flex items-center justify-center shadow-lg">
        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
        </svg>
      </div>
      <span className={`${theme === 'dark' ? 'bg-purple-500/20 text-purple-400' : 'bg-purple-50 text-purple-600'} px-3 py-1 rounded-full font-semibold text-sm`}>
        {data?.dataUsage?.percentage}
      </span>
    </div>
    <p className={`text-sm mb-2 font-medium ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>{t('enduser.dashboardOverview.datausage')}</p>
    <h3 className={`text-2xl font-bold mb-3 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
      {data?.dataUsage?.used} / {data?.dataUsage?.total}
    </h3>
    <div className={`w-full rounded-full h-2 ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-200'}`}>
      <div className="bg-blue-600 h-2 rounded-full transition-all duration-300" style={{ width: `${data?.dataUsage?.percentage ?? 0}%` }}></div>
    </div>
  </div>

  {/* Total Connections */}
  <div className={`${theme === 'dark' ? 'bg-[#333436] backdrop-blur-xl' : 'bg-white/80 backdrop-blur-xl'} rounded-2xl p-6 shadow-lg border ${theme === 'dark' ? 'border-gray-800' : 'border-gray-100'}`}>
    <div className="flex items-center justify-between mb-4">
      <div className="w-14 h-14 bg-green-600 rounded-2xl flex items-center justify-center shadow-lg">
        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      </div>
      <span className={`${theme === 'dark' ? 'bg-green-500/20 text-green-400' : 'bg-green-50 text-green-600'} px-3 py-1 rounded-full font-semibold text-sm flex items-center gap-1`}>
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
        {data?.totalConnections?.changePercentage}
      </span>
    </div>
    <p className={`text-sm mb-2 font-medium ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>{t('enduser.dashboardOverview.totalconnection')}</p>
    <h3 className={`text-2xl font-bold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
      {data?.totalConnections?.count}
    </h3>
    <p className={`text-sm font-medium ${theme === 'dark' ? 'text-gray-500' : 'text-gray-500'}`}>
      {data?.totalConnections?.period || t('enduser.dashboardOverview.totalconnectionduration')}
    </p>
  </div>

  {/* Active Devices */}
  <div className={`${theme === 'dark' ? 'bg-[#333436] backdrop-blur-xl' : 'bg-white/80 backdrop-blur-xl'} rounded-2xl p-6 shadow-lg border ${theme === 'dark' ? 'border-gray-800' : 'border-gray-100'}`}>
    <div className="flex items-center justify-between mb-4">
      <div className="w-14 h-14 bg-orange-600 rounded-2xl flex items-center justify-center shadow-lg">
        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      </div>
      <span className={`${theme === 'dark' ? 'bg-orange-500/20 text-orange-400' : 'bg-orange-50 text-orange-600'} px-3 py-1 rounded-full font-semibold text-sm`}>
        {data?.activeDevices?.changePercentage}
      </span>
    </div>
    <p className={`text-sm mb-2 font-medium ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>{t('enduser.dashboardOverview.activedevices')}</p>
    <h3 className={`text-2xl font-bold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
      {data?.activeDevices?.count}{data?.activeDevices?.limit ? `/${data.activeDevices.limit}` : ''}
    </h3>
    <p className={`text-sm font-medium ${theme === 'dark' ? 'text-gray-500' : 'text-gray-500'}`}>{t('enduser.dashboardOverview.Linkeddevices')}</p>
  </div>
</div>

{/* Bottom Grid */}
<div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
  {/* Active Subscription */}
  <div className={`${theme === 'dark' ? 'bg-[#333436]' : 'bg-white'} rounded-2xl p-5 shadow-lg border h-full flex flex-col ${theme === 'dark' ? 'border-gray-800' : 'border-gray-100'}`}>
    <div className="flex items-center justify-between mb-4">
      <div>
        <h3 className={`text-lg font-bold mb-0.5 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>{t('enduser.dashboardOverview.activesubscription')}</h3>
        <p className={`text-xs font-medium ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>{t('enduser.dashboardOverview.activesubscription2')}</p>
      </div>

      {activeSubscription && <span className="px-3 py-1 bg-blue-600 text-white rounded-full text-xs font-semibold">{t('enduser.dashboardOverview.autorenewon')}</span>}
    </div>

    <div className="mb-4">
      {activeSubscription?.plan?.name && (
        <div className={`${theme === 'dark' ? 'bg-gray-800/50' : 'bg-gray-50'} rounded-xl p-4 mb-4`}>
          <div className="flex items-center justify-between mb-3">
            <div>
              <h4 className={`text-base font-bold mb-0.5 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                 {activeSubscription.plan.name} ({activeSubscription.plan.period})
              </h4>
              <p className={`text-xs font-medium ${theme === 'dark' ? 'text-gray-500' : 'text-gray-500'}`}>
                Started {activeSubscription?.startDate ? new Date(activeSubscription?.startDate).toLocaleDateString() : ''}
              </p>
            </div>
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg">
              <Wifi className="w-6 h-6 text-white" />
            </div>
          </div>

          <div className="mb-2">
            <div className="flex justify-between text-xs mb-1.5">
              <span className={`font-semibold ${theme === 'dark' ? 'text-gray-400' : 'text-gray-700'}`}>{t('enduser.dashboardOverview.subscriptiondatausage')}</span>
              <span className={`font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                {subscription?.subscription?.dataUsage?.used} {subscription?.subscription?.dataUsage?.unit} / {subscription?.subscription?.dataUsage?.total}{subscription?.subscription?.dataUsage?.unit}
              </span>
            </div>
            <div className={`w-full rounded-full h-2 ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-200'}`}>
              <div className="bg-blue-600 h-2 rounded-full transition-all duration-300" style={{ width: `${subscription?.subscription?.dataUsage?.percentage}%` }}></div>
            </div>
          </div>
        </div>
      )}
    </div>

    {activeSubscription && (
      <div className="mt-auto flex gap-3">
        <button 
          onClick={() => { window.location.href = '/user/pricing'; }} 
          className="flex-1 bg-blue-600 text-white py-2.5 rounded-xl text-sm font-semibold hover:bg-blue-700 transition-colors shadow-md"
        >
          {t('enduser.dashboardOverview.upgradeplanbutton')}
        </button>
        <button  
          onClick={confirmCancelSubscription}  
          className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-colors ${theme === 'dark' ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
        >
          {cancelLoading ? t('enduser.dashboardOverview.loading') : t('enduser.dashboardOverview.cancelbutton')}
        </button>
      </div>
    )}
    
    {activeSubscription == null && (
      <div className="mt-auto flex flex-col justify-center gap-4">
        <div className={`mx-auto w-28 h-28 rounded-full ${theme === 'dark' ? 'bg-blue-500/10' : 'bg-blue-50'} flex items-center justify-center`}>
          <CreditCard className={`w-14 h-14 ${theme === 'dark' ? 'text-blue-400' : 'text-blue-600'} opacity-50`} />
        </div>
        <div className={`w-full text-center text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>{t('enduser.dashboardOverview.noactivesubscription')}</div>
        <button 
          onClick={() => window.location.href = '/user/pricing'}
          className="px-5 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-semibold hover:bg-blue-700 transition-colors shadow-md"
        >
          {t('enduser.dashboardOverview.subscribenow')}
        </button>
      </div>
    )}
  </div>

  {/* Quick Connect */}
  <div className="bg-blue-600 rounded-2xl p-5 shadow-lg">
    <div className="mb-4">
      <h3 className="text-lg font-bold text-white mb-1">{t('enduser.dashboardOverview.hotpotdashboardoverflowtitle')}</h3>
      <p className="text-white/90 text-xs font-medium">
        {t('enduser.dashboardOverview.hotpotdashboardoverflowtitle2')}
      </p>
    </div>

    <div className="relative bg-white/10 backdrop-blur-md rounded-xl p-4 mb-4 border border-white/20">
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
          <MapPin className="w-6 h-6 text-white" />
        </div>

        <div className="relative flex-1">
          <h4 className="font-bold text-base text-white mb-0.5">{t('enduser.dashboardOverview.findhotspots')}</h4>
          <p className="text-white/90 text-xs font-medium mb-3">
            {t('enduser.dashboardOverview.Discover')}
          </p>
        </div>
        
       </div>

        <div className="relative w-full">
              
              <button 
                onClick={()=> {
                  window.location.href = '/user/hotspots'
                }}
                className="w-full bg-white text-blue-600 border-0 pl-10 pr-3 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-white/50 font-medium shadow-lg text-sm flex gap-3 mt-4 justify-center items-center"><Wifi className="w-4 h-4 text-blue-600" /> <span>{t('enduser.dashboardOverview.findnearbyhotspot')}</span></button>

            
            </div>
          </div>  

          <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-white/20"></div>
              </div>
              <div className="relative flex justify-center text-xs uppercase">
                <span className="bg-gradient-to-br from-blue-600 to-indigo-600 px-2 text-blue-100">{t('enduser.dashboardOverview.or')}</span>
              </div>
          </div>

          <button 
            onClick={() => {
              navigator.geolocation.getCurrentPosition(
                async (position) => {
                  try {
                    const lat = position.coords.latitude;
                    const lon = position.coords.longitude;
                    
                    const response = await searchHotspots({ 
                      page: 1, 
                      limit: 10, 
                      latitude: lat, 
                      longitude: lon 
                    });
                    
                    const responseData = (response?.data || {}) as unknown;
                    const pagination = (responseData as Record<string, unknown>)?.pagination || {};
                    const hotspots = (responseData as Record<string, unknown>)?.hotspots || [];
                    
                    const count = (pagination as Record<string, unknown>).total !== undefined ? (pagination as Record<string, unknown>).total : (hotspots as unknown[]).length;
                    
                    setFeedbackData({
                      type: 'info',
                      title: t('enduser.dashboardOverview.availableHotspotsTitle', { defaultValue: 'Available Hotspots' }),
                      message: t('enduser.dashboardOverview.availableHotspotsCount', { defaultValue: `There are currently ${count} active hotspots available near you.` })
                    });
                    setShowFeedback(true);
                  } catch (err: unknown) {
                    setFeedbackData({
                      type: 'error',
                      title: 'Error',
                      message: 'Failed to fetch hotspots count'
                    });
                    setShowFeedback(true);
                  }
                },
                (error) => {
                  setFeedbackData({
                    type: 'error',
                    title: 'Location Required',
                    message: 'Please enable location services to scan for nearby hotspots.'
                  });
                  setShowFeedback(true);
                }
              );
            }}
            className="w-full bg-transparent text-white  pl-10 pr-3 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-white/50 font-medium shadow-lg text-sm flex gap-3 justify-center items-center border border-white/30 mt-4"
          >
            <Wifi className="w-4 h-4" /> 
            <span>{t('enduser.dashboardOverview.scanqrcodebutton')}</span>
          </button>

            </div>
        </div>
{/* Search Modal */}
<div className={`fixed top-[15%] ${theme === 'dark' ? 'bg-[#2a2b2d]' : 'bg-white'} w-[70%] rounded-2xl shadow-2xl z-50`} style={{display: searchdisplay ? 'block' : 'none'}}>
  <div className={`w-full flex items-center justify-between border-b-2 ${theme === 'dark' ? 'border-gray-700' : 'border-gray-200'} px-6 h-[4rem] ${theme === 'dark' ? 'bg-[#2a2b2d]' : 'bg-white'} rounded-t-2xl`}>
    <span className={`text-lg font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>{t('enduser.dashboardOverview.hotspotsearchmodal.hotspotmodalsearch_title')}</span>
    <X className='cursor-pointer hover:opacity-70 transition-opacity' onClick={() => setSearchDisplay(false)}/>
  </div>
  
  <div className='max-h-[400px] flex flex-col items-center overflow-y-auto p-4'>
    {searchData !== null && searchloading === false && searchData?.map((hotspot, index) => (
      <div key={index} 
        className={`w-full rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow border mb-4 ${
          theme === 'dark' ? 'bg-[#333436] border-gray-800' : 'bg-white border-gray-100'
        }`}
      >
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-4 mb-3">
              <h3 className={`text-2xl font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                {hotspot.name || t('enduser.hotspot.placeholders.unnamedHotspot')}
              </h3>
              {hotspot.isNew && (
                <span className="px-3 py-1 rounded-full text-sm font-semibold bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400">
                  New
                </span>
              )}
              <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                hotspot.status === 'active' 
                  ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
                  : 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400'
              }`}>
                {hotspot.status === 'active'
                  ? t('enduser.hotspot.connections.status.0')
                  : hotspot.status === 'inactive'
                  ? t('enduser.hotspot.connections.status.1')
                  : t('enduser.hotspot.placeholders.unknownStatus')}
              </span>
            </div>
            <div className={`text-lg mb-6 font-medium ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
              {hotspot.location?.address || t('enduser.hotspot.placeholders.noAddress')}, {hotspot.location?.city || t('enduser.hotspot.placeholders.noCity')}
            </div>
            
            <div className={`flex items-center gap-8 text-base mb-6 flex-wrap ${
              theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <div className="flex items-center gap-2">
                <MapPin className="w-5 h-5 text-gray-500" />
              </div>
              <div className="flex items-center gap-2">
                <Zap className="w-5 h-5 text-gray-500" />
                <span className="font-bold">{hotspot.speed || 0} {hotspot.speedUnit || 'Mbps'}</span>
              </div>
              <div className="flex items-center gap-2">
                <Users className="w-5 h-5 text-gray-500" />
                <span className="font-bold">{hotspot.userCount || 0} {t('enduser.hotspot.connections.user')}</span>
              </div>
            </div>

            <div>
              <div className={`flex items-center justify-between text-sm font-bold mb-2 ${
                theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
              }`}>
                <span>{t('enduser.hotspot.connections.networkstrenght')}</span>
                <span>{hotspot.signalStrength || 0}%</span>
              </div>
              <div className={`w-full rounded-full h-3 ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-200'}`}>
                <div className="h-3 rounded-full transition-all bg-green-600" />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3 ml-8">
            {/* 
            <button 
            onClick={async  ()=> {
               if(getconnectedhotspot === hotspot.id){
                 disconnecthotspot(getconnectedhotspot);
                } else {
                 await setSelectedHotspot(hotspot);
                 await confirmConnect(hotspot);
               }
            }}
              className="px-8 py-3.5 bg-blue-600 text-white rounded-xl font-semibold text-base transition-colors shadow-md hover:shadow-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {getconnectedhotspot === hotspot.id ? t('enduser.hotspot.connections.disconnectbutton')  : t('enduser.hotspot.connections.connectbutton')}
            </button> 
            */}
            <button 
              className={`px-8 py-3.5 border-2 rounded-xl font-semibold text-base transition-colors ${
                theme === 'dark' 
                  ? 'border-gray-700 text-gray-300 hover:bg-gray-700' 
                  : 'border-gray-300 text-gray-700 hover:bg-gray-50'
              }`}
            >
              {t('enduser.hotspot.connections.detailbutton')}
            </button>
          </div>
        </div>
      </div>
    ))}

    {searchloading === true ? (
      <div className="min-h-[10rem] w-full flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    ) : ''}
    
    {(searchData === null || searchData?.length === 0 && searchloading === false) && (
      <div className={`${theme === 'dark' ? 'text-white' : 'text-gray-900'} text-center my-10`}>{t('enduser.dashboardOverview.hotspotsearchmodal.hotspotsearcherror.no_found')}</div>
    )}
  </div>
</div>
{/* CLOSE THE SEARCH MODAL DIV HERE */}

{/* Recent Connections - NOW OUTSIDE THE SEARCH MODAL */}
<div className={`mt-6 ${theme === 'dark' ? 'bg-[#333436]' : 'bg-white'} rounded-2xl p-6 shadow-lg border ${theme === 'dark' ? 'border-gray-800' : 'border-gray-100'}`}>
  <div className="flex items-center justify-between mb-6">
    <div>
      <h3 className={`text-lg font-bold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>{t('enduser.dashboardOverview.recentConnections')}</h3>
      <p className={`text-sm font-medium ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>{t('enduser.dashboardOverview.recentConnectionsDesc')}</p>
    </div>
    <button className="text-blue-600 text-sm font-bold hover:text-blue-700">{t('enduser.dashboardOverview.viewallbutton')}</button>
  </div>

  <div className="space-y-4">
    {recentConnections && recentConnections.length > 0 ? (
      recentConnections.map((connection, index) => (
        <ConnectionItem
          name={String(((connection as unknown as Record<string, unknown>).hotspot as Record<string, unknown>)?.name || (connection as unknown as Record<string, unknown>).name || t('enduser.hotspot.placeholders.unknownHotspot'))}
          date={(connection as Record<string, unknown>).connectedAt ? new Date((connection as Record<string, unknown>).connectedAt as string).toLocaleDateString() : ""}
          duration={(connection as Record<string, unknown>).duration ?? ""}
          data={
            (connection as Record<string, unknown>).dataUsedUnit
              ? `${(connection as Record<string, unknown>).dataUsed} ${(connection as Record<string, unknown>).dataUsedUnit}`
              : (connection as Record<string, unknown>).dataUsed ?? ""
          }
          theme={theme}
          t={t}
          key={index}
        />
      ))
    ) : (
      <div className={`flex flex-col items-center justify-center py-16 ${theme === 'dark' ? 'bg-gray-800/30' : 'bg-gray-50'} rounded-2xl border-2 border-dashed ${theme === 'dark' ? 'border-gray-700' : 'border-gray-200'}`}>
        <div className={`w-20 h-20 rounded-full ${theme === 'dark' ? 'bg-blue-500/10' : 'bg-blue-50'} flex items-center justify-center mb-4`}>
          <Wifi className={`w-10 h-10 ${theme === 'dark' ? 'text-blue-400' : 'text-blue-600'} opacity-50`} />
        </div>
        <h4 className={`text-lg font-bold mb-2 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
          {t('enduser.dashboardOverview.noconnections')}
        </h4>
        <p className={`text-sm font-medium mb-6 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'} text-center max-w-sm`}>
          {t('enduser.dashboardOverview.noconnectionsdesc')}
        </p>
        <button 
           onClick={()=> {
                  window.location.href = '/user/hotspots'
                }}
          className="px-6 py-3 bg-blue-600 text-white rounded-xl text-sm font-semibold hover:bg-blue-700 transition-colors shadow-md flex items-center gap-2"
        >
          <Search className="w-4 h-4" />
          {t('enduser.dashboardOverview.findhotspots')}
        </button>
      </div>
    )}
  </div>
  
  {recentHasMore && recentConnections.length > 0 ? (
    <button
      onClick={handleLoadMoreRecent}
      className={`w-full mt-4 py-3 text-sm font-medium rounded-lg border transition-colors flex justify-center ${
        theme === 'dark'
          ? 'text-gray-300 border-gray-600 hover:bg-gray-800'
          : 'text-gray-700 border-gray-300 hover:bg-gray-50'
      }`}
    >
      {recentLoadingMore ? (
        <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
      ) : (
        t('enduser.dashboardOverview.loadmore')
      )}
    </button>
  ) : null}
</div>

</div> 

  <FeedbackModal
    isOpen={showFeedback}
    onClose={() => {
      setShowFeedback(false);
      if (reloadOnFeedbackClose) {
        setReloadOnFeedbackClose(false);
        window.location.reload();
      }
    }}
    type={feedbackData.type}
    title={feedbackData.title}
    message={feedbackData.message}
  />
    </>
  );
}

function ConnectionItem({ name, date, duration, data, theme, t }) {
  return (
    <div className={`flex items-center justify-between p-4 rounded-lg transition-colors ${theme === 'dark' ? 'bg-[#2a2b2d] hover:bg-gray-700' : 'bg-gray-50 hover:bg-gray-100'}`}>
      <div className="flex items-center gap-4">
        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
          <Wifi className="w-5 h-5 text-blue-600" />
        </div>
        <div>
          <h4 className={`font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>{name}</h4>
          <p className={`text-sm font-medium ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>{date} • {duration}</p>
        </div>
      </div>
      <div className="text-right">
        <p className={`font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>{data}</p>
        <p className="text-xs text-green-600 font-bold">{t('enduser.dashboardOverview.connectionstatus')}</p>
      </div>
    </div>
  );
}
// function ConnectionItem1(
// hotspot
//   // { name, date, duration, data, theme }
// ) {
//   const { theme } = useApp();

// return (
// <div 
//                   key={hotspot.id} 
//                   className={`w-full rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow border ${
//                     theme === 'dark' ? 'bg-[#333436] border-gray-800' : 'bg-white border-gray-100'
//                   }`}
//                 >
//                   <div className="flex items-start justify-between">
//                     <div className="flex-1">
//                       <div className="flex items-center gap-4 mb-3">
//                         <h3 className={`text-2xl font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
//                           {hotspot.name || 'Unnamed Hotspot'}
//                         </h3>
//                         <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
//                           hotspot.status === 'active' 
//                             ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
//                             : 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400'
//                         }`}>
//                           {hotspot.status || 'unknown'}
//                         </span>
//                       </div>
//                       <div className={`text-lg mb-6 font-medium ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
//                         {hotspot.location?.address || 'No address'}, {hotspot.location?.city || 'No city'}
//                       </div>
                      
//                       <div className={`flex items-center gap-8 text-base mb-6 flex-wrap ${
//                         theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
//                       }`}>
//                         <div className="flex items-center gap-2">
//                           <MapPin className="w-5 h-5 text-gray-500" />
//                           {/* <span className="font-bold">{formatDistance(hotspot.distance, hotspot.distanceUnit)}</span> */}
//                         </div>
//                         <div className="flex items-center gap-2">
//                           <Zap className="w-5 h-5 text-gray-500" />
//                           <span className="font-bold">{hotspot.speed || 0} {hotspot.speedUnit || 'Mbps'}</span>
//                         </div>
//                         <div className="flex items-center gap-2">
//                           <Users className="w-5 h-5 text-gray-500" />
//                           <span className="font-bold">{hotspot.userCount || 0} users</span>
//                         </div>
//                       </div>

//                       <div>
//                         <div className={`flex items-center justify-between text-sm font-bold mb-2 ${
//                           theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
//                         }`}>
//                           <span>Signal Strength</span>
//                           <span>{hotspot.signalStrength || 0}%</span>
//                         </div>
//                         <div className={`w-full rounded-full h-3 ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-200'}`}>
//                           <div
//                             className={`h-3 rounded-full transition-all ${
//                               // (hotspot.signalStrength || 0) >= 80 
//                                 // ?
//                                  'bg-green-600'
//                                 // : (hotspot.signalStrength || 0) >= 50
//                                 // ? 'bg-yellow-600'
//                                 // : 'bg-red-600'
//                             }`}
//                             // style={{ width: `${hotspot.signalStrength || 0}%` }}
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="flex flex-col gap-3 ml-8">
//                       <button 
//                         // onClick={() => handleConnect(hotspot)}
//                         // disabled={connectingHotspotId === hotspot.id || hotspot.status !== 'active'}
//                         className="px-8 py-3.5 bg-black dark:bg-blue-600 text-white rounded-xl font-medium text-base transition-colors shadow-md hover:shadow-lg hover:bg-gray-800 dark:hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
//                       >
//                         {/* {connectingHotspotId === hotspot.id ? (
//                           <>
//                             <Loader2 className="w-4 h-4 animate-spin" />
//                             Connecting...
//                           </>
//                         ) : (*/}
//                           Connect 
//                         {/* )} */}
//                       </button>
//                       <button 
//                         // onClick={() => handleViewDetails(hotspot)}
//                         className={`px-8 py-3.5 border-2 rounded-xl font-medium text-base transition-colors ${
//                           theme === 'dark' 
//                             ? 'border-gray-700 text-gray-300 hover:bg-gray-700' 
//                             : 'border-gray-300 text-gray-700 hover:bg-gray-50'
//                         }`}
//                       >
//                         View Details
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//                   );
// }
